module.exports = __webpack_public_path__ + "static/media/LOGO_La_Minerve.31484e46.jpg";